<template>
  <div class="video-index-page">
    <div :class="videoListShow?'list-btn list-btn-open':'list-btn'" @click="videoListShow=!videoListShow"><i :class="videoListShow?'el-icon-arrow-left':'el-icon-arrow-right'"></i></div>
    <div :class="videoListShow?'video-list video-list-open':'video-list'">
      <div class="list-box">
        <div class="left-head">
          摄像头列表
          <div class="add-camera"  @click="openEditWin('create')"><i class="el-icon-plus"></i></div>
        </div>
        <ul>
          <li v-for="(item, index) in videoList" :key="index">
            <template v-if="item.type==2">
              <div class="item-zu">
                <div class="item-one item-one-zu">
                  <div class="item-block" @click="item.show = !item.show">
                    <div class="file-icons"><i class="el-icon-folder"></i></div>
                    <span>{{item.title}}</span>
                  </div>
                  <el-dropdown trigger="click" class="device-set" @command="setCommand">
                    <div class="icons"><i class="el-icon-setting"></i></div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item class="drop-item" :command="{type:'update', item}">配置分组</el-dropdown-item>
                      <el-dropdown-item class="drop-item" :command="{type:'delete', item}">删除分组</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-show="item.child&&item.show" class="item-child">
                  <div v-for="(citem, j) in item.child" :key="j" class="item-one">
                    <span @click="setDeviceToBind(citem.number, citem.channel)">{{citem.title}}</span>
                    <el-dropdown trigger="click" class="device-set" @command="setCommand">
                      <div class="icons"><i class="el-icon-setting"></i></div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="drop-item" :command="{type:'update', item:citem}">配置修改</el-dropdown-item>
                        <el-dropdown-item class="drop-item" :command="{type:'delete', item:citem}">删除摄像头</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              
            </template>
            <template v-else>
              <div class="item-one">
                <span @click="setDeviceToBind(item.number, item.channel)">{{item.title}}</span>
                <el-dropdown trigger="click" class="device-set" @command="setCommand">
                  <div class="icons"><i class="el-icon-setting"></i></div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="drop-item" :command="{type:'update',item:item}">配置修改</el-dropdown-item>
                    <el-dropdown-item class="drop-item" :command="{type:'delete',item:item}">删除摄像头</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </div>
    <div class="video-box" :class="`videos-${videos.length}`">
      <video-box
        ref="child"
        class="video-preview"
        :class="{ 'is-binding': deviceToBind }"
        v-for="(video, index) in videos"
        :key="index"
        :activated="activatedVideo === video"
        :video="video"
        :rnd="video.rnd"
        @click.native="deviceToBind ? bindDevices(video) : activeVideo(video)">
      </video-box>
    </div>

    <div :class="controlShow?'control-btn control-btn-open':'control-btn'" @click="controlShow=!controlShow"><i :class="controlShow?'el-icon-arrow-right':'el-icon-arrow-left'"></i></div>
    <div :class="controlShow?'control-box control-open':'control-box'">
      <div class="control-con">
        <div class="video-control"><video-control :video="activatedVideo"></video-control></div>
        <div class="slice-box">
          <div class="slice-control">
            <div class="control-item" :class="videos.length==1?'curr':''" @click="createVideos(1)"></div>
          </div>
          <div class="slice-control">
            <div class="control-item" :class="videos.length==4?'curr':''" @click="createVideos(4)"><img src="@/assets/images/control-4.png" /></div>
          </div>
          <div class="slice-control">
            <div class="control-item" :class="videos.length==9?'curr':''" @click="createVideos(9)"><img src="@/assets/images/control-9.png" /></div>
          </div>
        </div>
      </div>
    </div>

    <!--新增对话框-->
    <el-dialog
      class="dialog650"
      :title="editType === 'create' ? '' : '摄像头配置修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left" 
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item label="名称" prop="title" class="xing-tips">
            <el-input v-model="editOne.title" placeholder="请输入摄像头名称"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select
              placeholder="请选择类型"
              v-model="editOne.type"
              style="width: 100%"
              :disabled="editOne.id?true:false"
            >
              <el-option label="摄像头" :value="1"></el-option>
              <el-option label="分组" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="editOne.type==1" label="所属分组">
            <el-select
              placeholder="请选择所属分组"
              v-model="editOne.pid"
              style="width: 100%"
            >
              <el-option label="顶级" :value="0"></el-option>
              <el-option
                v-for="t in groupList"
                :key="t.id"
                :label="t.title"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model="editOne.sort" placeholder="请输入排序"></el-input>
          </el-form-item>
          <template v-if="editOne.type==1">
            <el-form-item label="摄像头编号" prop="number">
              <el-input v-model="editOne.number" placeholder="请输入摄像头编号"></el-input>
            </el-form-item>
            <el-form-item label="摄像头协议">
              <el-select
                filterable 
                placeholder="请选择摄像头协议"
                v-model="editOne.camera_type"
                style="width: 100%"
              >
                <el-option label="海康萤石云" :value="1"></el-option>
                <el-option label="大华乐橙云" :value="2"></el-option>
                <el-option label="七牛云" :value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-if="editOne.camera_type==3" label="七牛云KEY">
              <el-input v-model="editOne.qiniu_key" placeholder="请输入七牛云KEY"></el-input>
            </el-form-item>
            <el-form-item v-if="editOne.camera_type==3" label="七牛云SECRET" >
              <el-input v-model="editOne.qiniu_secret" placeholder="请输入七牛云SECRET"></el-input>
            </el-form-item>

            <el-form-item label="选择路灯">
              <el-select
                clearable
                filterable 
                placeholder="请选择所属路灯"
                v-model="editOne.lamp_id"
                style="width: 100%"
              >
                <el-option
                  v-for="t in lampList"
                  :key="t.lamp_id"
                  :label="t.name"
                  :value="t.lamp_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>

          <el-form-item v-if="editOne.type==2" label="备注" >
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" v-model="editOne.desc" placeholder="请输入备注"></el-input>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="checkbox-item">
              <el-checkbox v-if="editOne.type==1" :true-label="1" :false-label="0" v-model="editOne.is_display">首页显示</el-checkbox>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box-footer">
              <el-button
                size="medium"
                class="cancel-btn"
                @click="dialogVisible = false"
                >取消</el-button >
  
              <el-button
                v-if="editType === 'create'"
                type="primary"
                size="medium"
                @click="createItem"
                >确定提交</el-button>
              <el-button
                v-if="editType === 'update'"
                type="primary"
                size="medium"
                @click="updateItem"
                >确定提交</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import lightListApi from "@/api/light/lightList";
import cameraApi from "@/api/light/camera";
import videoBox from '@/components/video/VideoBox.vue'
import videoControl from '@/components/video/VideoControl.vue'
export default {
  components: {
    videoBox,
    videoControl
  },
  data () {
    return {
      controlShow: true,
      videoListShow: true,
      videoList: [],
      groupList: [],
      videos: [],
      deviceToBind: null,
      activatedVideo: {},
      controlSpeed: 50,
      editType: -1,
      lampList: [],
      dialogVisible: false,
      editOne: {
        pid: 0,
        type:  1,
        sort: 1,
        number: '',
        title: '',
        camera_type: null,
        qiniu_key: '',
        qiniu_secret: '',
        lamp_id: null,
        is_display: 0,
        desc: ''
      },
      editOneRule: {
        title: [{ required: true, message: "请输入摄像头名称", trigger: "blur" }]
      }
    }
  },
  mounted () {
    this.getCamera()
    this.getLampList()
    this.createVideos(4)
  },
  methods: {
    getCamera() {
      cameraApi.cameraList({
        page: 1,
        pageSize: 200,
      }).then((res) => {
        if (res.data.code === 1000) {
          const resData = res.data.data
          if(resData.length) {
            let groupArr = []
            let newArr = resData.map(item => {
              return { ...item, show: false };
            })
            for(let i=0; i<newArr.length; i++){
              const type = newArr[i].type
              if(type==2){
                groupArr.push({
                  id: newArr[i].id,
                  title: newArr[i].title
                })
              }
            }
            this.groupList = groupArr
            this.videoList = newArr
          }else{
            this.groupList = []
            this.videoList = []
          }
        }
      });
    },
    createVideos (count) {
      if ([1, 4, 9].indexOf(count) < 0) {
        return
      }
      if (count > this.videos.length) {
        for (let i = this.videos.length; i < count; i++) {
          this.videos.push({
            index: i,
            number: '',
            camera_type: 1,
            channel: 1,
            access_token: '',
            rnd: Math.random()
          })
        }
      } else if (count < this.videos.length) {
        const videos = []
        for (let i = 0; i < count; i++) {
          videos.push(this.videos[i])
        }
        this.videos = videos
      }
    },
    setDeviceToBind (number,channel) {
      if (this.deviceToBind && this.deviceToBind.number === number) {
        this.deviceToBind = null
      } else {
        cameraApi.cameraInfo({
          number: number,
          channel: channel
        }).then((res) => {
          if (res.data.code === 1000) {
            const {camera_type, channel, access_token} = res.data.data
            this.deviceToBind = {
              number: number,
              camera_type: camera_type,
              channel: channel,
              access_token: access_token
            }
            this.activatedVideo = this.deviceToBind
          }
        })
      }
    },
    bindDevices (video) {
      video.rnd = Math.random()
      video.number = this.deviceToBind.number //设备序列号
      video.camera_type = this.deviceToBind.camera_type //设备序列号
      video.channel = this.deviceToBind.channel //通道号
      video.access_token = this.deviceToBind.access_token //通道号
      this.deviceToBind = null
    },
    activeVideo (video) {
      if (this.activatedVideo === video) {
        this.activatedVideo = null
      } else {
        this.activatedVideo = video
      }
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          pid: 0,
          type:  1,
          sort: 1,
          number: '',
          title: '',
          camera_type: null,
          qiniu_key: '',
          qiniu_secret: '',
          lamp_id: null,
          is_display: 0,
          desc: ''
        }
        this.editType = "create"
      } else {
        this.editOne = {
          id: index.id,
          pid: index.pid,
          type:  index.type,
          sort: index.sort,
          title: index.title,
          number: index.number,
          camera_type: index.camera_type,
          qiniu_key: index.qiniu_key,
          qiniu_secret: index.qiniu_secret,
          lamp_id: index.lamp_id,
          is_display: index.is_display,
          desc: index.desc
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },
    setCommand(command) {
      if(command.type=='update'){
        this.openEditWin(command.item)
      }else{
        this.delItem(command.item.id)
      }
    },
    updateItem() {
      cameraApi.cameraEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getCamera();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      cameraApi.cameraAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getCamera();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该摄像头，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cameraApi.cameraDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getCamera();
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getLampList() { // 获取路灯列表
      lightListApi.lightList({
        page: 1,
        pageSize: 500,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    }
  }
}
</script>

<style lang='less'>
.video-index-page {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  .list-btn{
    position: absolute;
    z-index: 999;
    left:40px;
    top:32px;
    background-color: #2d8cf0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    width:40px;
    height:40px;
    font-size: 28px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    transition: all 0.5s;
    &.list-btn-open{
      left:242px;
    }
  }
  .video-list{
    width:0;
    height:100%;
    overflow: hidden;
    background-color: #fff;
    transition: all 0.5s;
    box-sizing: border-box;
    &.video-list-open{
      width:262px;
    }
    .list-box{
      width:262px;
      padding:15px 20px 20px 25px;
      height:100%;
      overflow-y: auto;
      position: relative;
      box-sizing: border-box;
      .left-head{
        height:40px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: bold;
        color: #333;
        .add-camera{
          background-color: #2d8cf0;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          width:22px;
          height:22px;
          font-size: 16px;
          border-radius: 50%;
          cursor: pointer;
          font-weight: normal;
          margin-right: 10px;
        }
      }
      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        li{
          margin-top:10px;
          .item-one {
            margin-bottom: 10px;
            height:30px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            font-size: 14px;
            cursor: pointer;
            color:#444;
            padding-right: 30px;
            display: flex;
            align-items: center;
            position: relative;
            &:hover {
              color:#2d8cf0;
              .file-icons{
                color:#2d8cf0;
              }
            }
          }

          .item-one-zu{
            margin-bottom: 0;
            .item-block{
              display: flex;
              align-items: center;
            }
          }

          .item-child{
            padding-left: 22px;
            .item-one {
              margin-bottom: 0;
              font-size: 14px;
            }
          }

          .device-set{ 
            position: absolute;
            right:7px;
            top:0;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
          }
          .icons,.file-icons{
            color:#444;
            font-size: 16px;
            cursor: pointer;
          }

          .file-icons{
            font-size: 17px;
            margin-right: 5px;
          }
        }
        
      }
    }
  }
  .video-box{
    width:100%;
    height:100%;
    flex: 1;
    position: relative;
    padding:20px;
    box-sizing: border-box;
    background-color: #000;
  }
  .control-btn{
    position: absolute;
    z-index: 999;
    right:40px;
    bottom:40px;
    background-color: #2d8cf0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    width:40px;
    height:40px;
    font-size: 28px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    transition: all 0.5s;
    &.control-btn-open{
      right:538px;
      bottom:310px;
    }
  }
  .control-box{
    width:0;
    height:0;
    overflow: hidden;
    transition: all 0.5s;
    box-sizing: border-box;
    position: absolute;
    right:0;
    bottom: 0;
    z-index: 998;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    &.control-open{
      width:560px;
      height:380px;
    }
    .control-con{
      width:560px;
      height:380px;
      position: relative;
      box-sizing: border-box;
      background-color: #333333;
      display: flex;
      .video-control{
        flex: 1;
        width:100%;
        height:380px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .slice-box{
        border-left: 1px solid #000;
        width:140px;
        height:380px;
        display: flex;
        flex-direction: column;
        .slice-control{
          width:100%;
          flex:1;
          display: flex;
          align-items: center;
          justify-content: center;
          .control-item {
            width: 94px;
            height: 94px;
            border-radius: 8px;
            background: #1c2029;
            border:3px solid #333333;
            cursor: pointer;
            box-sizing: border-box;
            line-height: 0;
            img {
              width:100%;
              height:100%;
            }
            &.curr{
              border:3px solid #2d8cf0;
            }
          }
        }
      }
    }
  }
    
  .drop-item{
    font-size: 14px;
    color:#333;
    padding:2px 10px;
    text-align: center;
  }

  .video-container {
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
  }
  .videos-1 .video-container {
    width: 100%;
    height: 100%;
  }
  .videos-4 .video-container {
    width: 50%;
    height: 50%;
  }
  .videos-9 .video-container {
    width: 33.333333%;
    height: 33.333333%;
  }
  .video-preview.is-binding {
    cursor: pointer;
  }
  .video-preview.is-binding:before {
    content: '在这里显示';
    display: block;
    position: absolute;
    font-size: 24px;
    color: #fff;
    background: #000;
    width: 100%;
    height: 100%;
    text-align: center;
    box-sizing: border-box;
    padding-top: 2em;
    opacity: 0.5;
    z-index: 2;
  }
  .video-preview.is-binding:hover:before {
    opacity: 0.7;
  }

  .form-info{
    padding-left: 20px;
    .el-form-item__label{
      width:110px;
    }
  }
}
</style>
